import React, { Component } from "react";
import { Input } from "reactstrap";
import paperclip from "views/contactUs/img/paper-clip.png";
//IMG

class AllJobs extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <div>
        <card className="block rounded-12px drop-shadow20px">
          <div className="bgFDF1E7 rounded-t-12px p-3">
            <p className="textE77817 text-center fsize14">
              <b> Note :</b>
              <span className="font-medium ml-1">
                You had last written to us on 20th May, 2021.
              </span>
              <span className="text053C6D fsize14 underline font-semibold ">
                Check inbox
              </span>
            </p>
          </div>

          <form action="" className="p-10 bg-white rouned-b-12px">
            <h2 className="refer-h2 uppercase">WRITE TO US</h2>
            <div className="flex items-center justify-center w-full">
              <div class="form-group modal-form-cs mr-3 w-1/2">
                <label for="">Name</label>
                <input type="text" placeholder="" value="Username" />
              </div>

              <div class="form-group modal-form-cs ml-3 w-1/2">
                <label for="">Email ID</label>
                <input type="text" placeholder="" value="info@gmail.com" />
              </div>
            </div>

            <div class="form-group pt-6 modal-form-cs">
              <label for="">Your Query</label>
              <input
                type="text"
                staus
                className=" query-box"
                placeholder=""
                value="Type here..."
              />
            </div>

            <div className="modal-form-cs pt-6">
              <label for="">Reference</label>
              <div class="form-group items-center h-42px p-3 modal-form-cs w-full flex  bord-radius">
                <div className="mr-2">
                  <img src={paperclip} alt="paperclip" />
                </div>
                <p className="fsize16 text-black ">Attach file</p>
              </div>
            </div>

            <div class="w-full fixed-btn mt-12">
              <p class="btn btn-orange-otp btn-otp mx-auto myBtn" href="#">
                SUBMIT
              </p>
            </div>
          </form>
        </card>
      </div>
    );
  }
}
export default AllJobs;
